// -----------------------------
// swiper系
// -----------------------------

(function () {
  //swiper
  let accessSlide = new Swiper(".js-access-slide", {
    navigation: {
      nextEl: ".access-btn-next",
      prevEl: ".access-btn-prev",
    },
    pagination: {                       //ページネーション（ドット）
        el: '.access-pagination',
    },
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      769: {
        spaceBetween: 30,
        slidesPerView: 1,
      },
    },
  });
})();
